/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export var ContentType;
(function (ContentType) {
  ContentType['Json'] = 'application/json';
  ContentType['FormData'] = 'multipart/form-data';
  ContentType['UrlEncoded'] = 'application/x-www-form-urlencoded';
  ContentType['Text'] = 'text/plain';
})(ContentType || (ContentType = {}));
export class HttpClient {
  baseUrl = '';
  securityData = null;
  securityWorker;
  abortControllers = new Map();
  customFetch = (...fetchParams) => fetch(...fetchParams);
  baseApiParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };
  constructor(apiConfig = {}) {
    Object.assign(this, apiConfig);
  }
  setSecurityData = (data) => {
    this.securityData = data;
  };
  encodeQueryParam(key, value) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }
  addQueryParam(query, key) {
    return this.encodeQueryParam(key, query[key]);
  }
  addArrayQueryParam(query, key) {
    const value = query[key];
    return value.map((v) => this.encodeQueryParam(key, v)).join('&');
  }
  toQueryString(rawQuery) {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }
  addQueryParams(rawQuery) {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }
  contentFormatters = {
    [ContentType.Json]: (input) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
  };
  mergeRequestParams(params1, params2) {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }
  createAbortSignal = (cancelToken) => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }
    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };
  abortRequest = (cancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);
    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };
  request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;
    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response;
      r.data = null;
      r.error = null;
      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });
      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }
      return data;
    });
  };
}
/**
 * @title Portal API
 * @version 1.0.0
 */
export class Api {
  http;
  constructor(http) {
    this.http = http;
  }
  health = {
    /**
     * @description </br>Can be used to determine if the services is up and running</br>---</br>responses:</br>  200:</br>    description: Returned in case the services is running successfully.</br>    examples:</br>        application/json: { "runningSince": "2019-09-18T09:16:03.249000" }</br>tags:</br>    - health
     *
     * @tags Health
     * @name HealthHealthGet
     * @summary Health endpoint for checking if the service is up and running
     * @request GET:/api/v1/health
     */
    healthHealthGet: (query, params = {}) =>
      this.http.request({
        path: `/api/v1/health`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  docviewData = {
    /**
     * @description ---</br>parameters:</br>    - name: doc_id</br>      in: path</br>      description: An id of a single document to just list a single document</br>      type: integer</br>      example: 71cce094-e1b8-48f0-ae8e-ef1bb8f947f7</br>    - name: $(filters)</br>      in: body</br>      description: An object with list of metadata to update</br>      type: object</br>      example: { "level": "L1"}</br>responses:</br>    200:</br>        description: The file has been successfully updated</br>        examples:</br>            application/json:</br>                {</br>                    "data": [</br>                        {</br>                            "created_at": "2019-09-20T13:19:47.587Z",</br>                            "created_by_id": 8467,</br>                            "id": "71cce094-e1b8-48f0-ae8e-ef1bb8f947f7",</br>                            "file_name": "test.pdf",</br>                            "level": "L1",</br>                            "deleted_at": "2019-09-20T13:19:47.587Z",</br>                            "mimetype": "application/pdf",</br>                            "deleted_by_id": 8467</br>                        }</br>                    ]</br>                }</br>    400:</br>        description: In case of wrong request</br>    403:</br>        description: In case the user is not an admin</br>    500:</br>        description: if the document storage service can not be invoked</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - docviewData
     *
     * @tags docviewData
     * @name DocviewDataAdminUpdateDocviewDataStringDocIdPut
     * @summary Edits a document metadata
     * @request PUT:/api/v1/docviewData/{doc_id}
     * @secure
     */
    docviewDataAdminUpdateDocviewDataStringDocIdPut: (docId, params = {}) =>
      this.http.request({
        path: `/api/v1/docviewData/${docId}`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),
    /**
     * @description This endpoint retrieves all documents a tenant based on the provided filters in the request</br>---</br>parameters:</br>    - name: per_page</br>      in: query</br>      description: The number of entries to return per page. Max value is 1000.</br>      type: integer</br>      example: 25</br>    - name: page</br>      in: query</br>      description: The page of results to show</br>      type: integer</br>      example: 1</br>    - name: sort</br>      in: query</br>      description: The sorting order applied on documents</br>      type: string</br>      example: "file_name,asc;created_at,desc"</br>    - name: source</br>      in: body</br>      type: list[str]</br>      description: List of fields to return for a document</br>      example: ["virus_free", "created_at"]</br>      default: []</br>    - name: docs_ids</br>      in: body</br>      type: list[str]</br>      description: List of document ids to return/query</br>      example: [123, 245]</br>      default: null</br>    - name: $(filters)</br>      in: body</br>      type: object</br>      description: different filters applied by the user</br>      example: {</br>          "fund": 1,</br>          "level": "L1",</br>          "created_at": {</br>            "gte": "2022-05-15",</br>            "lte": "2022-05-31"</br>           }</br>        }</br>    - name: retrieve_url</br>      in: body</br>      type: bool</br>      description: whether return url of a document in the response or not</br>      default: False</br>responses:</br>    200:</br>        description: A list of values and page meta information based on the given filters</br>        examples:</br>            application/json:</br>                {</br>                  "data": [</br>                    {</br>                      "created_at": "2020-04-17T10:50:24.397104",</br>                      "created_by": {</br>                        "id": 11469,</br>                        "first_name": "Karim",</br>                        "last_name": "Akhnoukh"</br>                      },</br>                      "documentType": {</br>                        "id": 2,</br>                        "name": "Distributions"</br>                      },</br>                      "file_name": "sample.pdf",</br>                      "file_size": 8588,</br>                      "fund": {</br>                        "id": 1,</br>                        "name": "Fund 01"</br>                      },</br>                      "id": "ef27c960-fa2c-4dfa-a3b3-83c4fd76cb9c",</br>                      "investor": {</br>                        "id": 1,</br>                        "longName": "Max Maurer",</br>                        "shortName": "MM"</br>                      },</br>                      "level": "L1",</br>                      "mimetype": "application/pdf"</br>                    }</br>                  ],</br>                  "meta": {</br>                    "page": 1,</br>                    "pages": 1,</br>                    "per_page": 1,</br>                    "total": 1</br>                  }</br>                }</br>    500:</br>        description: if the document storage service can not be invoked</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - docviewData
     *
     * @tags docviewData
     * @name DocviewDataSearchAdminDocviewDataSearchPost
     * @summary Search all documents for a tenant
     * @request POST:/api/v1/docviewData/search
     * @secure
     */
    docviewDataSearchAdminDocviewDataSearchPost: (query, params = {}) =>
      this.http.request({
        path: `/api/v1/docviewData/search`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),
  };
  metadata = {
    /**
     * @description ---</br>responses:</br>    200:</br>        examples:</br>            application/json:</br>                {</br>                    "timestamp": 1706189576.739562</br>                }</br>    500:</br>        description: something wrong with the server</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - metadata
     *
     * @tags Metadata
     * @name MetadataVersionEndpointMetadataVersionGet
     * @summary Returns a Timestamp of the latest hulky updates for metadata
     * @request GET:/api/v1/metadata/__version
     * @secure
     */
    metadataVersionEndpointMetadataVersionGet: (params = {}) =>
      this.http.request({
        path: `/api/v1/metadata/__version`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
    /**
     * @description ---</br>parameters:</br>    - name: type</br>      in: path</br>      description: type for which all the corresponding ids and values mapping will be returned</br>      type: str</br>      example: document_type</br>responses:</br>    200:</br>        examples:</br>            application/json:</br>                {</br>                    "data": [</br>                        {'id': 1, 'name': 'Capital Call Notices'},</br>                        {'id': 2, 'name': 'Distribution Notices'},</br>                        {'id': 3, 'name': 'Capital Account Statements'}</br>                    ]</br>                }</br>    404:</br>        description: type not found</br>    500:</br>        description: something wrong with the server</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - metadata
     *
     * @tags Metadata
     * @name MetadataReferenceEndpointMetadataStringTypeGet
     * @summary Returns a list of all available values and their corresponding ids for a specific type
     * @request GET:/api/v1/metadata/{type}
     * @secure
     */
    metadataReferenceEndpointMetadataStringTypeGet: (type, params = {}) =>
      this.http.request({
        path: `/api/v1/metadata/${type}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
    /**
     * @description ---</br>responses:</br>    200:</br>        description: values have been added successfully</br>    400:</br>        description: In case of wrong request</br>    500:</br>        description: something wrong with the server</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - metadata
     *
     * @tags Metadata
     * @name DocviewMetadataReferenceInsertMetadataPost
     * @summary Adds metadata values to the corresponding reference table
     * @request POST:/api/v1/metadata
     * @secure
     */
    docviewMetadataReferenceInsertMetadataPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v1/metadata`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
    /**
     * @description Retrieve conditional-filtered values from the given metadatas' mappingInfoTable.</br>---</br>parameters:</br>    - name: relations</br>      in: body</br>      type: object</br>      description: list of relation queries that contains filter_by, source</br>      example: [</br>        {</br>          "filter_by": {</br>            "fund-metadata-id-or-key": ["TFUND_123"]</br>          },</br>          "source": ["investor", "fund"]</br>        }</br>      ]</br>responses:</br>    200:</br>        description: The relation filtering is successfully executed</br>        examples:</br>            application/json:</br>                {</br>                  "data": [</br>                    {</br>                      "fund": ["TFUND_123", "TFUND_234", "TFUND_345"],</br>                      "investor": ["TINV_001", "TINV_005"]</br>                    }</br>                  ]</br>                }</br>    400:</br>        description: In case of wrong request</br>    403:</br>        description: In case the user does not have sufficient scopes</br></br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - metadata
     *
     * @tags Metadata
     * @name MetadataFilterByRelationEndpointMetadataFilterByRelationPost
     * @summary General endpoint that works like modalValues.
     * @request POST:/api/v1/metadata/filter-by-relation
     * @secure
     */
    metadataFilterByRelationEndpointMetadataFilterByRelationPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v1/metadata/filter-by-relation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tenants = {
    /**
     * @description ---</br>parameters:</br>    - name: tenant_name</br>      description: The tenant name to fetch email logs. If not specified, this will fetch email logs for all tenants.</br>      required: false</br>      type: string</br>      in: body</br>      example: {"tenant_name": "Tenant 1"}</br>    - name: start_datetime</br>      description: An iso-formatted datetime string, from when you want to fetch email logs. Default value will be "2000-01-01"</br>      required: false</br>      type: string</br>      in: body</br>      example: {"start_datetime": "2000-01-01"}</br>    - name: end_datetime</br>      description: An iso-formatted datetime string, until when you want to fetch email logs. Default value will be datetime.now()</br>      required: false</br>      type: string</br>      in: body</br>      example: {"end_datetime": "2023-05-01T10:00:00"}</br>responses:</br>    200:</br>        description: Result of fetching the tenant email logs</br>        application/json: {</br>          "Tenant 1": "Succeed"</br>        }
     *
     * @tags Tenants
     * @name FetchEmailLogsTenantsFetchEmailLogsPost
     * @summary Fetch email logs from Mailgun
     * @request POST:/api/v1/tenants/fetch_email_logs
     * @secure
     */
    fetchEmailLogsTenantsFetchEmailLogsPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v1/tenants/fetch_email_logs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
    /**
     * @description ---</br>responses:</br>    200:</br>        description: Confirmation that zip was uploaded</br>        application/json: {</br>          "message": "ZIP was successfully uploaded"</br>        }
     *
     * @tags Tenants
     * @name TenantUploadZipTenantsUploadPost
     * @summary Zip upload of documents to MinIO.
     * @request POST:/api/v1/tenants/upload
     * @secure
     */
    tenantUploadZipTenantsUploadPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v1/tenants/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * @description ---</br>parameters:</br>    - name: cc</br>      in: body</br>      description: An object with list of CC</br>      type: object</br>      example: { "cc": ["jane.doe@asset-metrix.com"]}</br>    - name: bcc</br>      in: body</br>      description: An object with list of BCC</br>      type: object</br>      example: { "bcc": ["john.doe@asset-metrix.com"]}</br>    - name: investorIds</br>      in: body</br>      description: An object with list of investors to send email or if '*' in the list notifications will be</br>                   sent to all investors of the specified fund in fundId.</br>      type: object</br>      example: { "investorIds": ["MSINV1"]}</br>    - name: fundId</br>      in: body</br>      description: A string value of fund id to send email</br>      type: string</br>      example: { "fundId": "MSFUND1"}</br>    - name: fundName</br>      in: body</br>      description: A string value of fund Name to send email</br>      type: string</br>      example: { "fundName": "MS FUND 1"}</br>    - name: documentType</br>      in: body</br>      description: A string value describing the document type (can be used in the email template)</br>      type: string</br>      example: { "documentType": "test doc"}</br>    - name: dueDate</br>      in: body</br>      description: A string value describing the due date (can be used in the email template)</br>      type: string</br>      example: { "dueDate": "1st of October 2099"}</br>    - name: return_emails</br>      in: query</br>      description: Whether to return emails in response</br>      required: false</br>      type: boolean</br>      default: false</br>responses:</br>    200:</br>        description: emails have been sent successfully</br>    400:</br>        description: In case of wrong request</br>    500:</br>        description: something wrong with the server</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - notifications
     *
     * @tags Notifications
     * @name SendNotificationsToInvestorsNotificationsInvestorsPost
     * @summary Send notification email to investors
     * @request POST:/api/v1/notifications/investors
     * @secure
     */
    sendNotificationsToInvestorsNotificationsInvestorsPost: (data, query, params = {}) =>
      this.http.request({
        path: `/api/v1/notifications/investors`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  data = {
    /**
     * No description
     *
     * @tags Data
     * @name ContentDataGetDataPost
     * @request POST:/api/v2/data
     * @secure
     */
    contentDataGetDataPost: (data, query, params = {}) =>
      this.http.request({
        path: `/api/v2/data`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
    /**
     * No description
     *
     * @tags Data
     * @name DataFootersDataFootersPost
     * @request POST:/api/v2/data/footers
     * @secure
     */
    dataFootersDataFootersPost: (data, query, params = {}) =>
      this.http.request({
        path: `/api/v2/data/footers`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsSearchDocumentsPost
     * @request POST:/api/v2/documents
     * @secure
     */
    documentsSearchDocumentsPost: (data, query, params = {}) =>
      this.http.request({
        path: `/api/v2/documents`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
    /**
     * @description </br>This endpoint streams the content of a document directly through the browser.
     *
     * @tags Documents
     * @name DocumentsDownloadDocumentsDownloadPost
     * @summary Download a document by its ID
     * @request POST:/api/v2/documents/download
     * @secure
     */
    documentsDownloadDocumentsDownloadPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v2/documents/download`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  auth = {
    /**
     * @description ---</br>parameters:</br>    - name: token</br>      in: body</br>      description: Current JWT</br>      type: object</br>      example: ey1234321.asd123.23123</br>    - name: refresh_token</br>      in: body</br>      description: Refresh JWT</br>      type: object</br>      example: ey1234321.asd123.23123</br>responses:</br>    200: {}</br>security:</br>    - token: []</br>    - apiId: []</br>tags:</br>    - authentication
     *
     * @tags Auth
     * @name LogoutLogoutPost
     * @summary Logout and invalidate token
     * @request POST:/api/v1/logout
     * @secure
     */
    logoutLogoutPost: (data, params = {}) =>
      this.http.request({
        path: `/api/v1/logout`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
